import { getDigitainUrl } from "@actions/thirdParty";
import React, { useEffect, useRef } from "react";
import Bootstrapper from "./assets/js/bootstrapper";
import "./assets/js/digitain";

export default function Digitain({ sessionId, currentLanguage }) {
	const isMobileRef = useRef(null);
	const isLatinoUI = window.DIGITAIN_LATINO_UI === true;
	useEffect(() => {
		window.addEventListener("resize", renderSB);
		renderSB().then((b) => {
			const digitain = document.querySelector("sport-mobile");
			if (digitain) {
				const shadowRoot = digitain.shadowRoot;
				const sportMobile = shadowRoot.querySelector("#sport-mobile");

				const observer = new MutationObserver((mutationsList, observer) => {
					for (const mutation of mutationsList) {
						if (mutation.type === "childList") {
							const shadowElement = sportMobile.querySelector(".dm__betslip--single");
							if (shadowElement) {
								shadowElement.style.bottom = "70px";
								observer.disconnect();
							}
						}
					}
				});

				observer.observe(sportMobile, { childList: true, subtree: true });

				const shadowElement = sportMobile.querySelector(".dm__betslip--single");
				if (shadowElement) {
					shadowElement.style.bottom = "70px";
					observer.disconnect();
				}
			}
		});
		return () => {
			if (window.SportFrame?.elem) {
				window.SportFrame.destroy();
			}
			window.removeEventListener("resize", renderSB);
		};
	}, [renderSB]);

	const renderSB = async () => {
		const isMobile = window.innerWidth < 1024;

		if (isMobileRef.current === isMobile) return;

		isMobileRef.current = isMobile;

		async function getToken() {
			try {
				const response = await getDigitainUrl();
				return response?.data?.token ?? "-";
			} catch (error) {
				console.error("Request failed:", error.message);
				return "-";
			}
		}

		document.querySelector("#sport_div_iframe").innerHTML = "";

		if (window.SportFrame && !isMobile && !isLatinoUI) {
			console.log("SportFrame", window.SportFrame);
			var sp = [
				["server", window.DIGITAIN_HOST],
				["token", sessionId && sessionId !== "" ? await getToken() : "-"],
				["currentPage", "Home"],
				["language", currentLanguage || "en"],
				["sportPartner", window.DIGITAIN_TOKEN],
				["oddsFormat", window.DIGITAIN_ODD_FORMAT],
				["userId", sessionId && sessionId !== "" ? sessionId : ""],
				["parent", [window.DIGITAIN_PARENT_DOMAIN]],
			];
			window.SportFrame.frame(sp);
		} else if (isMobile || isLatinoUI) {
			console.log("Bootstrapper", Bootstrapper);
			const params = {
				server: window.DIGITAIN_HOST,
				token: sessionId && sessionId !== "" ? await getToken() : "-",
				containerId: "sport_div_iframe",
				oddsFormat: window.DIGITAIN_ODD_FORMAT,
				defaultLanguage: currentLanguage || "en",
				sportPartner: window.DIGITAIN_TOKEN,
				userId: sessionId && sessionId !== "" ? sessionId : "",
			};
			return await Bootstrapper.boot(params, {
				name: isLatinoUI ? "LatinoView" : "Mobile",
			});
		}
	};

	return <div id="sport_div_iframe"></div>;
}
